/// <amd-module name="Build/Admin/Pool/Stores/DescriptionStore" />
import { Store } from "VSS/Reflux/Store";

import { StoreStatus } from "Build/Admin/Common/Constants";

export interface IDescriptionStoreState {
    description: string;
    status: StoreStatus;
}

export class DescriptionStore extends Store {
    public state: IDescriptionStoreState = {
        description: "",
        status: StoreStatus.None
    };

    constructor() {
        super("DescriptionStoreChanged");
    }

    public updateAgentPoolDescription = (description: string) => {
        this.state = {
            description,
            status: StoreStatus.Loaded
        };
        this.emitChanged();
    }

    public updateStatus = (status: StoreStatus): void => {
        this.state = {
            ...this.state,
            status
        };
        this.emitChanged();
    }
}
